import { parseNewlines } from 'utils/stringUtils';
import xss from 'xss';

export const createTitle = (title: string) => ({
  __html: parseNewlines(xss(title)),
});
